import { FC } from 'react';
import { Link } from 'react-router';
import { RouterConfig } from '@edikk-edikk/shared';
import { FooterLinkType } from '@edikk-edikk/country-frontend';
import footerLinkCss from '#srcCssModules/footer/footer-link.module.scss';

type PropsType = {
  footerLink: FooterLinkType;
};

const FooterLink: FC<PropsType> = ({
  footerLink,
}) => (
  <Link
    to={footerLink.slug}
    state={{ routerConfig: RouterConfig.initForPage(footerLink.id) }}
    className={footerLinkCss.footerLink}
  >
    {footerLink.title}
  </Link>
);

export { FooterLink };
